import React from 'react';
import {
  TableRow,
  TableCell,
  Checkbox,
  Typography,
  Box,
  Tooltip,
} from '@mui/material';
import UtmDetails from '../common/UtmDetails';

const TableRowComponent = ({ user, handleSelectRow, isChecked }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? 'Invalid Date'
      : new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
  };

  const renderUTMInfo = () => {
    return <UtmDetails row={user} />;
  };

  const renderLocation = () => {
    if (!user?.country && !user?.city) return 'N/A';

    return (
      <>
        <strong>Country:</strong> {user?.country || '-'}
        <br />
        <strong>City:</strong> {user?.city || '-'}
      </>
    );
  };



  const StyledCell = ({ children }) => (
    <TableCell sx={{ fontSize: '0.9rem', padding: '12px', verticalAlign: 'top' }}>
      <Tooltip title={children || 'N/A'} arrow>
        <Typography
          variant="body1"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 220,
          }}
        >
          {children || 'N/A'}
        </Typography>
      </Tooltip>
    </TableCell>
  );

  return (
    <TableRow hover>
      <TableCell sx={{ padding: '12px', width: 60 }}>
        <Checkbox
          checked={isChecked}
          onChange={() => handleSelectRow(user.id)}
          disableRipple
          sx={{
            '&:hover': { backgroundColor: 'transparent' },
          }}
        />
      </TableCell>

      <StyledCell>{user?.id}</StyledCell>
      <StyledCell>{user?.user_name}</StyledCell>
      <StyledCell>{user?.user_email}</StyledCell>
      <StyledCell>{user?.product_name}</StyledCell>
      <StyledCell>{formatDate(user?.createdAt)}</StyledCell>

      {/* ✅ Single UTM Column */}
      <TableCell sx={{ verticalAlign: 'top', padding: '12px' }}>
        {renderUTMInfo()}
      </TableCell>

      {/* ✅ Country + City as object */}
      <TableCell sx={{ verticalAlign: 'top', padding: '12px' }}>
        {renderLocation()}
      </TableCell>
    </TableRow>
  );
};

export default TableRowComponent;
